/* PD carousel: cross-fading slides with dots, auto-advance, swipe and pause on hover/focus.
   Used by the hero campaign card. Re-inits after a soft navigation and in the theme editor. */
(function () {
  function init(root) {
    if (root.dataset.pdCarouselInit) return; root.dataset.pdCarouselInit = "1";
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-pd-slide]"));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-pd-dot]"));
    var i = slides.findIndex(function (s) { return s.classList.contains("is-on"); }); if (i < 0) i = 0;
    var wait = (parseFloat(root.dataset.interval) || 6) * 1000, timer = null, paused = false;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); s.setAttribute("aria-hidden", k === i ? "false" : "true"); });
      dots.forEach(function (d, k) { d.classList.toggle("is-on", k === i); d.setAttribute("aria-selected", k === i ? "true" : "false"); });
    }
    function play() { stop(); if (!paused && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) timer = setInterval(function () { show(i + 1); }, wait); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d) { d.addEventListener("click", function () { show(Number(d.dataset.pdDot)); play(); }); });
    root.addEventListener("mouseenter", function () { paused = true; stop(); });
    root.addEventListener("mouseleave", function () { paused = false; play(); });
    root.addEventListener("focusin", function () { paused = true; stop(); });
    root.addEventListener("focusout", function () { paused = false; play(); });
    var x0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); play(); } x0 = null; }, { passive: true });
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else play(); });
    show(i); play();
  }
  function all(scope) { (scope || document).querySelectorAll("[data-pd-carousel]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { all(); }); else all();
  document.addEventListener("pd:navigated", function () { all(); });
  document.addEventListener("shopify:section:load", function (e) { all(e.target); });
})();
